import actions from "./actions";

const initialState = {
  detail: {},
  requestKey: {},
  loading: false,
  error: false,
};

export default function licenseReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
